<template>
  <div class="index">
    <el-container>
      <el-header style="height:.6rem">
        <headers></headers>
      </el-header>
      <el-container>
        <el-aside class="leftBackground" style="width: auto">
          <left></left>
        </el-aside>
        <el-main>
          <!--router tab-->
          <page-tab></page-tab>
          <div class="content-box" ref="scrollContainer">
            <transition name="fade" mode="out-in">
              <router-view v-if="alive"></router-view>
            </transition>
          </div>
          <div class="dial-center" v-show="isCallEnable" @click="initSoftphone"
            :style="{ top: positionY + 'px', right: '0' }">☎️</div>

          <div id="callStyle">
            <el-dialog :title="$t('来电提示')" :close-on-click-modal="false" :append-to-body="false" :fullscreen="false"
              :modal-append-to-body="false" :modal="false" :visible.sync="OrderDetailDialog" width="1200" center
              @close="delClaer">
              <div class="fx" style="width:100%;">
                <div class="leftbox">
                  <div class="tabbox " :class="{ 'avt': avtive == 1 }" @click="tabChang(1)">
                    来电信息
                  </div>
                  <div class="tabbox" :class="{ 'avt': avtive == 2 }" @click="tabChang(2)">
                    通话记录
                  </div>
                  <div class="tabbox" :class="{ 'avt': avtive == 3 }" @click="tabChang(3)">
                    设备信息
                  </div>


                </div>
                <div class="rightbox">
                  <Incoming v-if="avtive == 1" :caller="PROPScaller" :cc_job_id="tid"></Incoming>
                  <callList v-if="avtive == 2" :user_id="callDetail.id"></callList>
                  <device v-if="avtive == 3" :caller="PROPScaller" :cc_job_id="tid"></device>
                </div>

              </div>

            </el-dialog>
          </div>
        </el-main>
      </el-container>
      <!-- 免开发模式需配置 html -->
      <!-- 电话条展示区 -->
      <!-- <div id="view"></div> -->
      <!-- 网络监听展示区 -->
      <!-- <div id="rttHTML"></div> -->
    </el-container>
  </div>
</template>

<script>
// import YSYTAgentSdk from 'ysyt-agent-sdk';
import headers from "../components/header";
import left from "../components/left.vue";
import pageTab from "../components/pageTab.vue";
import Incoming from "../components/CallTab/Incoming";
import callList from "../components/CallTab/callList";
import device from "../components/CallTab/device";
import bus from "../libs/bus";
import { get, post, ws_URL } from "../libs/tool";
import {
  api_getEmployeeDetailY,
  updateCallRecordOnCallRelease,
  addCallRecordOnCall,
  getUserCallInfo,
  getUserCallList1,
  getCallRecordListByJobId,
  saveUserCall,
  agentLogin,
  agentLogout,
  statusChange
} from "../api/api";
export default {
  name: "index",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      msg: "路由承接页",
      // LeftWidth: "180px",
      alive: true,
      currentLoginName: "", //当前登录用户
      tid: "",

      setRuleShow: false, //体温
      setRuleShow2: false, //在离家
      setRuleShow3: false, //血压
      setRuleShow4: false, //心率
      setRuleShow5: false, //sos
      setRuleShow6: false, //跌倒
      setRuleShow7: false, //电子围栏
      setRuleShow8: false, //特殊提醒
      setRuleShow9: false, //烟感提醒
      setRuleShow10: false, //运动心率

      // 异常预警警报
      abnormalUser: "", //用户名
      phoneNum: "", //联系电话
      abnormalTime: "", //发生时间
      abnormalTemperature: "", //异常体温值
      abnormalLocation: "", //发生位置
      //体温异常预警弹窗的信息
      temperatureInfo: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        temperature: "",
        address: "",
      },
      // 在离家弹窗信息
      suspectedToHomeInfo: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      },
      // 血压异常弹窗信息
      dysarteriotony: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        sbp: "",
        dbp: "",
      },
      // 心率异常弹窗信息
      abnormalities: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        heartrate: "",
      },
      // sos弹窗信息
      SOSemergency: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      },
      // 跌倒
      fallWarning: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      },
      // 电子围栏
      fenceWarning: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      },
      //特殊提醒异常预警弹窗的信息
      SpecialRemindInfo: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        alertText: "",
        address: "",
      },
      //烟感预警弹窗的信息
      NtwarningInfo: {
        imei: "",
        organization: {
          name: "",
        },
        time_begin: "",
        alarm_desc: "",
        building: {
          name: "",
        },
        floor: {
          floor_no: "",
        },
        room: {
          room_no: "",
        },
        cell: {
          cell_no: "",
        },
      },
      // 运动心率
      EXSwarningInfo: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      },
      auth: "",
      socket: "",


      callEnable: true,
      callStatus: '未登录',
      networkStatus: '检测中...',
      // 配置参数
      config: {
        accountName: '',
        password: '',
        loginType: 'WEBRTC',
        // UI配置
        phoneMoveMsg: {
          isDraggable: true, //false不可移动，true可移动
          position: { top: 550, left: 1000 } // 移动位置top,left,bottom,right
        },

      },
      ueSimple: null,
      yseUsername: '',
      isCallEnable: false,
      liant: true,
      positionY: window.innerHeight / 2 - 393, // 初始居中
      isDragging: false,
      showWorkbench: true,
      workbenchHeight: 400,
      startY: 0,
      initialY: 0,
      clickThreshold: 5,
      isWorkbenchVisible: true,
      OrderDetailDialog: false,
      parent_job_id: '',
      mapObj: null,
      tid: "",
      CallRecordListByJobId: [],
      callDetail: {},
      Dialogwidth: '600px',
      isMap: false,
      avtive: 1,
    };
  },
  components: { headers, left, pageTab, Incoming, callList, device },
  mounted() {
    this.$nextTick(() => {
      console.log("YSYTAgentSdk", YSYTAgentSdk);
    })
    let that = this;
    let auth = localStorage.getItem("auth");
    this.$nextTick(function () {
      //有缓存就取缓存
      if (auth != "null") {
        //          console.log(auth)
        auth = typeof auth == "object" ? auth : JSON.parse(auth);

        that.$store.commit("change_auth", auth);
      }

      //根据不同的返回orginId加载不同的styl
      //2c928efd6657fa51016665f570180001
      if (auth.organization.id == "000000006b6d88bc016c4ac8f22914bf") {
        console.log("加载css");
        $("#styles").attr("href", "./static/css/bb.css");
      }
    });
    auth = typeof auth == "object" ? auth : JSON.parse(auth);
    this.auth = auth;
    bus.$on("aacc", function () {
      console.log("我切换了003");
      that.alive = false;
      that.$nextTick(() => {
        that.alive = true;
      });
    });
    // this.socketInit();
    if (localStorage.getItem("createLogin") == 1) {
      localStorage.removeItem("createLogin");
      this.$router.go(0);
    }
    window.scrollTo(0, 0);

    this.$nextTick(() => {
      // this.loginF()
    })
    this.getCallData()
  },
  methods: {
    tabChang(tab) {
      this.avtive = tab;
    },
    getCallData() {
      console.log('获取呼叫配置', this.auth.ccc_config.username);
      if (this.auth.ccc_config.username) {
        this.isCallEnable = true
        this.config.accountName = this.auth.ccc_config.username
        this.config.password = this.auth.ccc_config.password
      } else {
        this.isCallEnable = false
      }
    },
    delClaer() {
      this.OrderDetailDialog = false;
      this.isMap = false;
      this.CallRecordListByJobId = []
      this.callDetail = {}
      this.parent_job_id = ''
      this.tid = ''
      this.visitValue = 0
      this.visitTime = ''
      this.vTextarea = ''
      this.visit_plan_time_begin = []
    },
    initSoftphone() {
      // 初始化电话条
      let that = this;
      that.ueSimple = window.ueSimpleSoftphone.init({
        accountName: this.config.accountName,
        password: this.config.password,
        loginType: 'WEBRTC',
        // UI配置
        phoneMoveMsg: {
          isDraggable: true, //false不可移动，true可移动
          position: { top: 70, right: 80 } // 移动位置top,left,bottom,right
        },
        // 网络检测事件
        listenCallNetork: function (event) {
          console.log('易用的--网络检测事件', event)
        },
        listenCallEvent: function (event) {
          console.log('易用的--外部事件接收：', event)
          if (event == 'connect event serve success!') {
            that.$message({
              message: "上线成功！",
              type: "success",
            });
            // that.$store.commit("statusCode", 1);

            post(agentLogin, { username: that.config.accountName, employee_id: that.auth.id }, (res) => {
              if (res.success) {
                console.log(res, '上线');
                that.isCallEnable = false;
                that.CallEnable = false;
                bus.$emit('getEmployeeListByDate')

                if (window.workbench) {
                  window.workbench.unloadWorkbench();
                }
              }
            });
          }
          if (event.callType == "callin") {
            that.tid = event.callId
            that.PROPScaller = event.customerNumber
            that.avtive = 1
            that.getUserCallInfo(event.customerNumber);
          }
        },
        listenCallQueueEvent: function (event) {
          console.log('易用的--监听呼叫队列', event)
        },

      })
      console.log('ueSimpleSoftphone:', window.ueSimpleSoftphone);

      this.callStatus = '已初始化';
    },
    getUserCallInfo(caller) {

      // getUserCallInfo
      get(getUserCallList1, {
        caller: caller,
      }, (res) => {
        if (res.success) {
          console.log(res, '来电用户信息');
          this.OrderDetailDialog = true
          if (res.data.length > 0) {
            this.callDetail = res.data[0];
            console.log(this.callDetail, '来电用户信息');
            if (this.callDetail.device.length > 0) {
              this.Dialogwidth = '900px';
              this.isMap = true;
              // this.$nextTick(() => {
              //   this.initMap(this.callDetail.device[0].lon, this.callDetail.device[0].lat)
              // })
            } else {
              this.Dialogwidth = '600px';
            }
          }
        } else {
          // alert("系统异常，请稍后重试！", res);
        }
      });

    },
    startDrag(e) {
      this.isDragging = true
      this.startY = e.clientY
      this.initialY = this.positionY
    },
    handleDrag(e) {
      if (!this.isDragging) return

      const deltaY = e.clientY - this.startY
      const newY = this.initialY + deltaY
      const maxY = window.innerHeight - 50 // 按钮高度

      this.positionY = Math.max(0, Math.min(newY, maxY))
    },
    stopDrag(e) {
      if (!this.isDragging) return
      this.isDragging = false

      // // 判断点击事件（移动距离小于阈值）
      if (Math.abs(e.clientY - this.startY) < this.clickThreshold) {
        // this.toggleWorkbench()
        console.log("点击事件", e.clientY, this.startY, this.clickThreshold)
        this.callEnable = !this.callEnable
        if (window.workbench) {
          window.workbench.changeVisible(this.callEnable)
        }

      }
    },
    toggleWorkbench() {
      console.log("toggleWorkbench");

      // 保持按钮在可视范围内
      this.positionY = Math.min(
        this.positionY,
        window.innerHeight - 50
      )
    },
    handleResize() {
      // 窗口大小变化时保持位置
      this.positionY = Math.min(
        this.positionY,
        window.innerHeight - 50
      )
    },
    loginF() {
      let that = this;
      this.$nextTick(() => {
        const sdk = YSYTAgentSdk.default.getInstance({
          agentNo: that.auth.ccc_config.username,
          appKey: that.auth.ccc_config.app_key,
          appSecret: that.auth.ccc_config.app_secret,
        });
        const viewDiv = document.querySelector('#view');
        const rttHTML = document.querySelector('#rttHTML');
        sdk.init({
          actionNodeParams: {
            viewHtmlElement: viewDiv, rttHTML,
          },
        });
      })

    },

    processing(num) {
      if (num == 1) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow = false;
      }
      if (num == 2) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow2 = false;
      }
      if (num == 3) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow3 = false;
      }
      if (num == 4) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow4 = false;
      }
      if (num == 5) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow5 = false;
      }
      if (num == 6) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow6 = false;
      }
      if (num == 7) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow7 = false;
      }
      if (num == 8) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow8 = false;
      }
      if (num == 9) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow9 = false;
      }
      if (num == 10) {
        this.$router.push("/index/warningDeal");
        this.setRuleShow10 = false;
      }
    },
    reload() {
      let that = this;
      this.alive = false;
      this.$nextTick(function () {
        that.alive = true;
      });
    },
    //初始化websocket
    socketInit() {
      let that = this;
      let loginid = this.auth.id;
      // console.log("loginid001", loginid);

      let ws = new WebSocket(
        ws_URL +
        "/smart-care/chat?" +
        loginid +
        "_" +
        that.auth.organization.id
      );

      this.socket = ws;

      //连接成功
      ws.onopen = function () {
        console.log("头部连接成功");

        //that.socket.send('{"message":"loginid_organ", "loginId":"'+ that.currentLoginId +'", "organId":"' + that.auth.organ_id + '"}')

        //添加防超时逻辑
        //          that.checkTimeOut();
      };

      //接受服务器端信息回调
      ws.onmessage = function (res) {
        //   console.log('接受服务器端信息回调', res);

        let dat =
          typeof res.data === "object" ? res.data : JSON.parse(res.data);

        console.log("接受服务器端信息回调", dat);
        console.log("信息", dat.message, dat.type);


        let falg = false;
        if (that.auth.grade == 1 && dat.data.organization) {
          if (dat.data.organization.id == that.auth.organization.id) {
            falg = true;
          } else {
            falg = false;
          }
        }
        if (that.auth.grade == 2 && dat.data.community) {
          if (
            dat.data.organization.id == that.auth.organization.id &&
            dat.data.community.id == that.auth.community.id
          ) {
            falg = true;
          } else {
            falg = false;
          }
        }
        if (that.auth.grade == 3 && dat.data.sub) {
          if (
            dat.data.organization.id == that.auth.organization.id &&
            dat.data.community.id == that.auth.community.id &&
            dat.data.sub.id == that.auth.sub.id
          ) {
            falg = true;
          } else {
            falg = false;
          }
        }

        if (dat.data && falg) {
          // 如果是这个类型，是sos紧急呼叫
          if (dat.data.channel == "SOS_CHANNEL") {
            let queryData = {
              address: dat.data.address,
              city: dat.data.city,
              is_disposed: dat.data.is_disposed,
              time_begin: dat.data.time_begin,
              imei: dat.data.imei,
              lon: dat.data.lon,
              type: dat.data.type,
              lat: dat.data.lat,
              organ_id: dat.data.organization.id,
              user_name: dat.data.owner
                ? dat.data.owner.name
                  ? dat.data.owner.name
                  : ""
                : "",
              user_phone: dat.data.owner
                ? dat.data.owner.mobile_phone
                  ? dat.data.owner.mobile_phone
                  : ""
                : "",
            };
            let routeData = that.$router.resolve({
              name: "detailMap",
              query: queryData,
            });
            window.open(
              routeData.href,
              "_blank",
              "height=620, width=1100, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no"
            );

            that.SOSemergency = {};
            that.setRuleShow5 = true;
            that.SOSemergency = dat.data;
          } else if (dat.data.channel == "TEMPERATURE_CHANNEL") {
            that.temperatureInfo = {};
            console.log("我异常了");
            if (
              that.auth.role.warning_show_type != 1 &&
              !that.auth.role.is_super_administrator &&
              that.auth.role.warning_temperature_enable == 1
            ) {
              that.setRuleShow = true;
            }

            that.temperatureInfo = dat.data;
            console.log("弹窗数据", that.temperatureInfo);
          } else if (dat.data.channel == "WIFIHOME_CHANNEL") {
            that.suspectedToHomeInfo = {};
            if (
              that.auth.role.warning_show_type != 1 &&
              !that.auth.role.is_super_administrator &&
              that.auth.role.warning_wifihome_enable == 1
            ) {
              that.setRuleShow2 = true;
            }
            that.suspectedToHomeInfo = dat.data;
            console.log("弹窗数据", that.suspectedToHomeInfo);
          } else if (dat.data.channel == "BLOODPRESSURE_CHANNEL") {
            that.dysarteriotony = {};
            if (
              that.auth.role.warning_show_type != 1 &&
              !that.auth.role.is_super_administrator &&
              that.auth.role.warning_bloodpressure_enable == 1
            ) {
              that.setRuleShow3 = true;
            }
            that.dysarteriotony = dat.data;
            console.log("弹窗数据", that.dysarteriotony);
          } else if (dat.data.channel == "HEARTRATE_CHANNEL") {
            that.abnormalities = {};
            if (
              that.auth.role.warning_show_type != 1 &&
              !that.auth.role.is_super_administrator &&
              that.auth.role.warning_heartrate_enable == 1
            ) {
              that.setRuleShow4 = true;
            }
            that.abnormalities = dat.data;
            console.log("弹窗数据", that.abnormalities);
          } else if (dat.data.channel == "FALL_CHANNEL") {
            that.fallWarning = {};
            if (
              that.auth.role.warning_show_type != 1 &&
              !that.auth.role.is_super_administrator &&
              that.auth.role.warning_fall_enable == 1
            ) {
              that.setRuleShow6 = true;
            }
            that.fallWarning = dat.data;
            console.log("弹窗数据", that.fallWarning);
          } else if (dat.data.channel == "FENCE_CHANNEL") {
            that.fenceWarning = {};
            if (
              that.auth.role.warning_show_type != 1 &&
              !that.auth.role.is_super_administrator &&
              that.auth.role.warning_fence_enable == 1
            ) {
              that.setRuleShow7 = true;
            }
            that.fenceWarning = dat.data;
            console.log("弹窗数据", that.fenceWarning);
          } else if (dat.data.channel == "ALERT_REPLY_CHANNEL") {
            that.SpecialRemindInfo = {};
            if (
              that.auth.role.warning_show_type != 1 &&
              !that.auth.role.is_super_administrator &&
              that.auth.role.warning_alertreply_enable == 1
            ) {
              that.setRuleShow8 = true;
            }
            that.SpecialRemindInfo = dat.data;
            console.log("弹窗数据", that.SpecialRemindInfo);
          } else if (dat.data.channel == "SMOKE_DETECTOR_CHANNEL") {
            that.setRuleShow9 = true;
            that.NtwarningInfo = dat.data;
            console.log(that.NtwarningInfo, "烟感弹窗数据");
          } else if (dat.data.channel == "EXERCISE_HEARTRATE_CHANNEL") {
            if (
              that.auth.role.warning_show_type != 1 &&
              !that.auth.role.is_super_administrator &&
              that.auth.role.warning_exercise_heartrate_enable == 1
            ) {
              that.EXSwarningInfo = dat.data;
              that.setRuleShow10 = true;
              console.log(that.EXSwarningInfo, "运动心率弹窗数据");
            }
          }
        }
      };
      //连接关闭回调
      ws.onclose = function () {
        console.log("连接关闭111111");
      };
      //连接出错
      ws.onerror = function () {
        console.log("连接出错");
      };
    },
  },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  #view{
    position: fixed;
    left: 100px;
    top: 100px;
    z-index: 1000;
  }
$color1 = red;
.rightbox{
  flex:1;
  padding-left: 10px;
}
#callStyle{
  >>>.el-dialog__wrapper{
    z-index: 1!important;
  }
  >>>.el-dialog {
    margin-top: 6vh !important;
    width: 1200px!important;
    height: 700px!important;
}}
.dial-center {
  position: fixed;
  right: 0;
  width: 50px;
  font-size: 18px;
  height: 50px;
  background: #fff;
  color: white;
  border-radius: 50% 0 0 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  box-shadow: -2px 0 5px rgba(0,0,0,0.2);
  transition: right 0.3s, top 0.3s;
  // z-index:1000;
  z-index: 3!important;
}
.fade-enter-active, .fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter, .fade-leave-active {
  opacity: 0;
  transform: translateX(-30px);
}
.fade-enter-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

.leftbox{
 .tabbox{
  padding: 10px;
  font-size: 18px;
  font-weight: 700;
  writing-mode: vertical-rl;
  border:1px solid #ddd;
  border-radius: 10px;
  cursor: pointer;
 }
}
.avt{
  background: #ff7624;
  color:#fff;
}
.rightbox{
  flex:1;
  padding-left: 10px;
}

.index {
  width: 100%;
  height: 100%;
}

.el-header {
  /* background-color: #242424 */
  color: #333;
  text-align: center;
  padding: 0;
  box-shadow: 0 12px 10px -10px rgba(0, 0, 0, 0.1) !important;
  margin-bottom: 6px;
}

.el-aside {
  height: 100%;
  color: #333;
  text-align: center;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  // padding: 5px 0px 0px 0;
  position: relative;
  transition: all 0.3s;
  box-shadow: 3px 3px 6px 0px rgba(0,0,0,0.06); 
}

.el-main {
  color: #333;
  text-align: center;
  padding: 0;
  margin: 4px 0px 10px 10px;
  position: relative;
  background: #f7f7f7;
  border-radius: 15px;
  overflow: hidden;

  .content-box {
    width: 100%;
    box-sizing: border-box;
    height: calc(100% - 0.5rem);
    overflow-y: auto;
    scroll-behavior: smooth;
  }

  .breakNav {
    position: absolute;
    left: 20px;
    top: 20px;
    font-weight: bold;
  }
}

.el-container {
  height: 100%;

  >.el-container {
    height: calc(100% - 0.9rem);
    width: 100%;
    // background: $color1;
  }
}

.home {
  width: 100%;
  height: 100%;
}

/deep/.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}

/deep/ .el-dialog__header {
  // padding: 20px;
  font-size: 16px;
  text-align: center;
  background: #ff6320;
  color: #fff;
}

/deep/ .el-dialog__title {
  color: #fff;
}

/deep/ .el-dialog__body {
  padding: 20px;
}

.service-title {
  position: absolute;
  top: 15px;
  color: #fff;
  text-align: center;
}

.order-data {
  .user-i-name {
    display: flex;
    align-items: center;
    margin: 35px 10px;
  }

  .u-i-left {
    margin-right: 10px;
    width: 100px;
    text-align: right;
  }

  .new-save {
    width: 200px;
    background: #ff7624;
    text-align: center;
    margin: 40px auto 0;
    padding: 15px 0;
    border-radius: 25px;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue